<button
  class="btn btn-sm btn-light"
  (click)="$event.stopPropagation(); openModal()"
  >
  <i class="fas fa-chart-bar"></i>
</button>
<ng-template #stockGraphicModal let-modal>
  <div class="modal-header">
    <div class="col-md-12">
      <span class="modal-title">
        <span class="font-weight-bold">
          {{ app.text.stock.modalTitle }}
        </span>
        @if (cpn !== '' || mpn !== '') {
          <span>-</span>
        }
        @if (cpn !== '') {
          <span>
            {{ app.field.getLabel("thread.artNumber") }} :
            {{ app.thread.thread["thread.artNumber"] }}
          </span>
        }
        @if (mpn !== '') {
          <span>
            {{ app.field.getLabel("thread.crtNumber") }} :
            {{ app.thread.thread["thread.crtNumber"] }}
          </span>
        }
      </span>
    </div>
  </div>
  <div class="modal-body">
    @if (noData) {
      <div class="col-md-12 text-center font-weight-bold">
        {{ app.text.stock.noData }}
      </div>
    }
    @if (noCpn) {
      <div class="col-md-12 text-center font-weight-bold">
        {{ app.text.stock.noCPN }}
      </div>
    }
    @if (!noCpn && !noData) {
      <div
        #stockChartContainer
        class="stock-chart-host"
      ></div>
    }
  </div>
  <div class="modal-footer">
    <button class="btn btn-cancel text-center m-1" (click)="closeModal()">
      {{ app.text.stock.close }}
    </button>
  </div>
</ng-template>
